import React, { Fragment, useEffect, useRef } from "react";
import { Marker } from "react-leaflet";
import { v4 as uuidv4 } from "uuid";
import { useAppSelector } from "store/hooks/useAppSelector";
import { useGetDriversPositionQuery } from "store/api";
import { ExtendedMarker, RotatedMarkerProps } from "./types";
import { shallowEqual } from "react-redux";
import useMapIcons from "hooks/useMapIcons/useMapIcons";
import "leaflet-rotatedmarker";

export const RotatedMarker: React.FC<RotatedMarkerProps> = ({
  position,
  bearing,
}) => {
  const markerRef = useRef<ExtendedMarker | null>(null);
  const { carIcon } = useMapIcons();

  useEffect(() => {
    if (markerRef.current && bearing) {
      markerRef.current?.setRotationAngle(bearing);
      markerRef.current?.setRotationOrigin("center center");
    }
  }, [bearing]);

  return <Marker ref={markerRef} position={position} icon={carIcon} />;
};

const DriversPosition = () => {
  const srcAddress = useAppSelector(
    (state) => state.srcAddress.srcAddressRoute,
  );
  const radius = useAppSelector(
    (state) => state.settings.config.radius,
    shallowEqual,
  );
  const cityCenter = useAppSelector(
    (state) => state.settings.config.cityCenter,
  );
  const searchLat = srcAddress?.lat || cityCenter.lat;
  const searchLng = srcAddress?.lng || cityCenter.lng;
  const { data: driversPosition, isSuccess } = useGetDriversPositionQuery(
    {
      lat: searchLat,
      lng: searchLng,
      radius: srcAddress.lat ? radius.defaultRadius : radius.maxRadius,
    },
    {
      pollingInterval: 10000,
    },
  );

  return (
    <>
      {isSuccess && (
        <>
          {driversPosition?.map((driver) => (
            <Fragment key={uuidv4()}>
              {driver.state === "Free" && (
                <RotatedMarker
                  position={[
                    driver.drivercar_position.lat,
                    driver.drivercar_position.lng,
                  ]}
                  bearing={driver.drivercar_position.bearing}
                />
              )}
            </Fragment>
          ))}
        </>
      )}
    </>
  );
};

export default DriversPosition;
